import { UserCanDoActionMemo } from "../../../engine/AuthRoute";
import routes from "../../../engine/routes";
import { Col } from "antd";
import { CustomCard } from "../../../shared/components/CustomCard/CustomCard";
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getEstimationCost } from "../Slices/Prestation.slice";
import {
  formatCurrency,
  statusPrestationsValues,
} from "../../../utils/constants";
import { RenderCosts } from "../../../shared/components/Billing/RenderCosts";
import { RenderBillInfo } from "../../../shared/components/Billing/RenderBillInfo";

export const PrestationEstimationCost = ({ estimation = false }) => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const { prestation, loading, ready, dangerousUpdate, cost } = useSelector(
    state => state.prestation,
  );

  const getCost = async () => {
    if (
      prestation._id !== undefined &&
      [
        statusPrestationsValues.draft,
        statusPrestationsValues.waiting,
        statusPrestationsValues.planned,
        statusPrestationsValues.finish,
        statusPrestationsValues.finish_notsigned,
        statusPrestationsValues.finish_permanance,
      ].includes(prestation.status)
    ) {
      await dispatch(getEstimationCost(id));
    }
  };

  useEffect(() => {
    if (cost === null && estimation) {
      getCost();
    }
  }, [id, ready, prestation]);

  useEffect(() => {
    if (cost === null && estimation) {
      getCost();
    }
  }, []);

  return (
    <UserCanDoActionMemo route={routes.billing(id).detail} action={"r"}>
      <Col span={24}>
        <RenderCosts
          prestationVue={true}
          prestation={prestation}
          title={
            estimation
              ? "Estimation des coûts minimaux, sans frais de déplacement de l’interprète."
              : "Coûts de la prestation"
          }
          cost={estimation ? cost : prestation?.bill}
          loading={loading}
        />
      </Col>
    </UserCanDoActionMemo>
  );
};
